// ScrollToTop.tsx

import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * ページ遷移時にスクロール位置をトップにリセットするコンポーネント
 * - PUSH ナビゲーション（通常のリンククリック）時のみスクロールをリセットする
 * - ブラウザバックなどによる遷移ではリセットしない
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();

  // PUSH（通常のリンククリック）のときにスクロールをトップにリセットする
  useEffect(() => {
    if (navigationType === "PUSH") {
      window.scrollTo(0, 0);
    }
  }, [pathname, navigationType]);

  return null;
};
